import React, { useEffect, useRef, useState } from 'react';
import styles from './test.module.scss';
import useApi from 'src/Api/useApi';
import {
  Autocomplete,
  Box,
  Button,
  CircularProgress,
  Divider,
  IconButton,
  Paper,
  TextField,
} from '@mui/material';
import Typography from '@mui/material/Typography';
import FileUpload from 'src/components/ui/fileUpload';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import Page from './pdfCoordVisualization/page';

const panels = ['json', 'pageResult'];

const TestPage = () => {
  const { api, inProgress } = useApi();

  const [resJson, setResJson] = useState();
  const [expanded, setExpanded] = useState();
  const [recognitionResult, setRecognitionResult] = useState();
  const [spaceId, setSpaceId] = useState('');
  const [spaces, setSpaces] = useState([]);
  const [autocompleteInput, setAutocompleteInput] = useState('');

  useEffect(() => {
    const local = async () => {
      const data = await api('analysis/spaces', null);

      data?.length && setSpaces(data);
      data?.length && setSpaceId(data[0]);
    };

    local();
  }, []);

  const onUploadStart = () => {
    setResJson(null)
    setRecognitionResult(null)
  }

  const onUploadFinish = async (result) => {
    if (!result) {
      return;
    }

    const { res, recognizedData } = result;
    setExpanded(panels[0]);
    setResJson(JSON.parse(res)?.pages);
    setRecognitionResult(
      recognizedData?.questions?.filter((i) => i.recognizedData)
    );
  };

  const onPanelClick = (name) => {
    setExpanded(expanded === name ? '' : name);
  };

  const handleResultCopyClick = () => {
    navigator.clipboard.writeText(resJson);
  };

  return (
    <Paper className={styles.paper}>
      <Typography variant="h6" p={3}>
        Обработать данные из файла
      </Typography>
      <Divider variant="fullWidth" />

      <Divider variant="fullWidth" />
      <Box p={3}>
        <Autocomplete
          value={spaceId || null}
          onChange={(event, newValue) => {
            setSpaceId(newValue);
          }}
          inputValue={autocompleteInput}
          onInputChange={(event, newInputValue) => {
            setAutocompleteInput(newInputValue);
          }}
          options={spaces}
          isOptionEqualToValue={(o, v) => o.id === v.id}
          getOptionLabel={(option) => `${option.name} - ${option.id}`}
          renderInput={(params) => (
            <TextField {...params} label="Id пространства" />
          )}
        />
        <Box pt={3}>
          <FileUpload
            url={'file/processPdfJson'}
            onUploadFinish={onUploadFinish}
            onUploadStart={onUploadStart}
            additionalData={[{ code: 'spaceId', value: spaceId.id }]}
            disabled={!spaceId}
          />
        </Box>
      </Box>
      <Divider variant="fullWidth" />

      <Accordion
        expanded={expanded === panels[0]}
        onChange={() => onPanelClick(panels[0])}
        TransitionProps={{ timeout: { appear: 1, enter: 1, exit: 4 } }}
      >
        <AccordionSummary
          style={{
            position: 'sticky',
            top: '-20px',
            background: 'white',
            zIndex: 10,
          }}
          expandIcon={<ExpandMoreIcon />}
        >
          <Typography pl={1}>Визуализация документа</Typography>
        </AccordionSummary>
        <AccordionDetails>
          {recognitionResult &&
            resJson.map((i) => (
              <Page
                key={i.pageNumber}
                pageData={i}
                recognizedData={recognitionResult}
              />
            ))}
        </AccordionDetails>
      </Accordion>
      <Accordion
        expanded={expanded === panels[1]}
        onChange={() => onPanelClick(panels[1])}
        TransitionProps={{ timeout: { appear: 1, enter: 1, exit: 4 } }}
      >
        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
          <Typography variant="body1" p={1}>
            Результат распознавания
            <IconButton
              onClick={handleResultCopyClick}
              color="primary"
              disabled={!resJson}
            >
              <ContentCopyIcon />
            </IconButton>
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Box p={3}>{JSON.stringify(resJson)}</Box>
        </AccordionDetails>
      </Accordion>
    </Paper>
  );
};

export default TestPage;
